import type { EntityAssignment } from '../../types/workflow';

/**
 * Helper text under a Sales Agent picker (DRI-85). Only claims a rep goes on the invoice when the
 * link is KNOWN to exist; an unknown link state (undefined) gets neutral wording.
 */
export function salesAgentRepHint(salesAgent: EntityAssignment | null | undefined): string {
  if (!salesAgent) return "Optional — the agent's Sage Sales Rep (if linked) goes on this workflow's invoice.";
  if (salesAgent.hasSageSalesRepLink === true) return "This agent's Sage Sales Rep goes on this workflow's invoice.";
  if (salesAgent.hasSageSalesRepLink === false) {
    return 'Not linked to a Sage Sales Rep — the invoice will carry no sales rep. Link one on the agent.';
  }
  return "If this agent is linked to a Sage Sales Rep, that rep goes on this workflow's invoice.";
}
